const Tooltip = ({ text }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 10,
        right: 10,
        textAlign: "left",
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "6px",
        boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        zIndex: 0,
      }}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  )
}

export default Tooltip
